import useColors from 'hooks/useColors';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { IconArrow } from './icons';
import { SettingsItem, SettingsItemContent, SettingsItemDescription, SettingsItemRightContent, SettingsItemTitle, } from './SettingsItem';
import Spacer from './Spacer';
import Squircle from './Squircle';
import { rem } from './values';
import TimeInfo from './TimeInfo';
export const TimeToCompleteItem = ({ title, description, estimatedTimeToComplete, icon, onPress, }) => {
    const colors = useColors();
    return (<SettingsItem onPress={onPress}>
      <SettingsItemContent>
        <TimeInfo title={estimatedTimeToComplete}/>
        <SettingsItemTitle>{title}</SettingsItemTitle>
        <SettingsItemDescription>{description}</SettingsItemDescription>
      </SettingsItemContent>
      <SettingsItemRightContent>
        {icon ? (<View style={styles.row}>
            <Spacer w={16}/>
            <Squircle width={rem(44)} height={rem(44)} color={colors.background.dark}>
              {icon}
            </Squircle>
          </View>) : (<IconArrow />)}
      </SettingsItemRightContent>
    </SettingsItem>);
};
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        alignItems: 'center',
    },
});
